<script lang="ts" setup>
import { ErrorLayout } from '@app/panel/Layouts';
import {
  DescriptionList,
  DescriptionListDescription,
  DescriptionListItem,
  DescriptionListTerm,
  Link,
} from '@returnless/focus-ui';

defineProps<{
  status: string | number;
  requestId?: string;
}>();
</script>

<template>
  <ErrorLayout
    :status="status"
    title="Oops. Something went wrong!"
  >
    <p>
      There's a technical problem with Returnless that has prevented this page from loading. Try reloading this page or
      going to another page in Returnless. If that doesn't work, visit our
      <Link
        href="https://status.returnless.com"
        external
      >
        status page
      </Link>
      for update and try again later.
    </p>

    <DescriptionList align="vertical">
      <DescriptionListItem>
        <DescriptionListTerm>Error code</DescriptionListTerm>
        <DescriptionListDescription>{{ status }}</DescriptionListDescription>
      </DescriptionListItem>
      <DescriptionListItem>
        <DescriptionListTerm>Request ID</DescriptionListTerm>
        <DescriptionListDescription>{{ requestId }}</DescriptionListDescription>
      </DescriptionListItem>
    </DescriptionList>
  </ErrorLayout>
</template>
